import { MenuItem } from '@mui/material';
import clsx from 'clsx';
import styles from './UserInfoMenuItem.module.scss';

const UserInfoMenuItem = ({ Icon, iconProps, text, onClick, isDelete }) => {
  const url = window.location.href;

  return (
    <MenuItem className={styles.menuItemWrapper} onClick={onClick}>
      <div className={styles.iconWrapper}>
        <Icon {...iconProps} />
      </div>
      <div className={clsx(styles.text, isDelete ? styles.delete : '')}>{text}</div>
    </MenuItem>
  );
};

export default UserInfoMenuItem;
